import styled from 'styled-components';
import { Table as OzoneTable } from 'components/molecules/table';
import { SingleLineEllipsis } from 'components/styles';

export const Table = styled(OzoneTable)`
  .ant-table-cell {
    padding: 0px var(--spacing-05);
  }
`;

export const Cell = styled.div`
  p {
    width: calc(100% - 32px);
    margin-bottom: 0px;
    ${SingleLineEllipsis};
  }

  button:not(.reload-button) {
    display: none;
  }

  display: flex;
  padding: var(--spacing-05) 0px;
  justify-content: space-between;
  align-items: center;
  height: 50px;

  &:hover button:not(.reload-button) {
    display: flex;
  }
`;
